<script lang="ts" setup>
  import LoadingSpinnerEmpty from '~/assets/images/loading-spinner-empty.svg'

  withDefaults(
    defineProps<{
      size?: 'sm' | 'md' | 'lg' | 'xl'
      color?: string
    }>(),
    {
      size: 'sm',
      color: 'var(--color-base-paper)'
    }
  )
</script>

<template>
  <ion-icon
    :class="`spinner spinner-size-${size}`"
    :icon="LoadingSpinnerEmpty"
    :style="{
      color
    }"
  />
</template>

<style lang="scss" scoped>
  .spinner {
    animation: spinner 4s linear infinite;
  }

  .spinner-size-sm {
    width: 24px;
    height: 24px;
  }

  .spinner-size-md {
    width: 48px;
    height: 48px;
  }

  .spinner-size-lg {
    width: 96px;
    height: 96px;
  }

  .spinner-size-xl {
    width: 160px;
    height: 160px;
  }

  @keyframes spinner {
    100% {
      transform: rotate(360deg);
    }
  }
</style>
